import { Effect, Reducer, history } from 'umi';
import { message } from 'antd';
import { queryLogin, logout, queryOauthLogin } from '@/services/login';

const LoginModel = {
  namespace: 'login',
  state: {
    userInfo: {
      userId: '',
      name: '',
    },
    isError: false,
  },
  effects: {
    *queryLogin({ payload, callback }, { call, put }) {
      const response = yield call(queryLogin, { ...payload });
      if (response.code === '00000') {
        yield put({
          type: 'save',
          payload: {
            userInfo: response.data,
          },
        });

        localStorage.setItem('userInfo', JSON.stringify(response.data));

        message.success('登录成功！');
        if (callback && typeof callback === 'function') {
          callback(response); // 返回结果
        }
        // history.replace('/');
      } else {
        yield put({
          type: 'save',
          payload: {
            isError: true,
          },
        });
        if (callback && typeof callback === 'function') {
          callback(response); // 返回结果
        }
        message.success('登录失败！');
      }
    },

    *queryOauthLogin({ payload }, { call, put }) {
      const response = yield call(queryOauthLogin, { ...payload });
      if (response.code === '00000') {
        yield put({
          type: 'save',
          payload: {
            userInfo: response.data,
          },
        });

        localStorage.setItem('userInfo', JSON.stringify(response.data));

        message.success('登录成功！');
        history.replace('/');
      } else {
        message.success(`登录失败` + response.msg);
        yield put({
          type: 'save',
          payload: {
            isError: true,
          },
        });
      }
    },

    *getUserInfo({ payload }, { call, put, select }) {
      const { name } = yield select((state) => state.global);
      const data = yield call(queryLogin, { ...payload, name });
      yield put({
        type: 'save',
        payload: {
          userInfo: data,
        },
      });
    },
    *logout(_, { call }) {
      const response = yield call(logout);
      if (response.code === '00000') {
        // 手动退出记录当前路径
        localStorage.setItem('nextPath', window.location.href);

        localStorage.removeItem('userInfo');
        history.replace({
          pathname: '/login',
          search: `timestamp=${new Date().getTime()}`,
        });
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    // 启用 immer 之后
    // save(state, action) {
    //   state.name = action.payload;
    // },
  },
};

export default LoginModel;
